import axiosBase from "axios";
import { SERVER_URL } from "../settings";


const axios = axiosBase.create({
	baseURL: SERVER_URL
});

export default axios;